var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action',_vm._g(_vm._b({class:_vm.$classes['form-append-btn'],attrs:{"variant":"flat","color":"secondary","disabled":_vm.disabled}},'action',_vm.$attrs,false),_vm.$listeners),[_c('icon',{attrs:{"name":_vm.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }